import axios from '@util/axios'

export const UserService = {
  create: (newData) =>
    axios({
      url: `/member/`,
      method: 'POST',
      data: newData
    }),
  read: (id) =>
    axios({
      url: `/member/${id}/`
    }),
  patch: (id, updatedDataPart) =>
    axios({
      url: `/member/${id}/`,
      method: 'PATCH',
      data: updatedDataPart
    }),
  put: (id, updatedData) =>
    axios({
      url: `/member/${id}/`,
      method: 'PUT',
      data: updatedData
    }),
  delete: (id) =>
    axios({
      url: `/member/${id}/`,
      method: 'DELETE'
    })
}
